import { render, staticRenderFns } from "./SupplierPublicSearch.vue?vue&type=template&id=a10eece4&scoped=true&"
import script from "./SupplierPublicSearch.vue?vue&type=script&lang=ts&"
export * from "./SupplierPublicSearch.vue?vue&type=script&lang=ts&"
import style0 from "./SupplierPublicSearch.vue?vue&type=style&index=0&id=a10eece4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10eece4",
  null
  
)

export default component.exports